import React, { FC, InputHTMLAttributes } from 'react';
import clsx from 'clsx';

import styles from './styles.module.scss';

type InputProps = InputHTMLAttributes<HTMLInputElement> &
  Readonly<{ label: string; className?: string; hasError?: boolean; name: string }>;

export const Input: FC<InputProps> = ({ className, label, name, hasError = false, ...inputProps }) => {
  return (
    <div className={styles.container}>
      <input id={name} className={clsx(styles.inputWrapper, { [styles.inputError]: hasError }, className)} {...inputProps} />
      <label className={styles.label} htmlFor={name}>{label}</label>
    </div>
  );
};

